// @mui material components
import { GetApp, Visibility } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function InvoicesActionCell({ invoice }) {
  const handleView = () => {
    const url = new URL(window.location.href);
    const invoceUrl = `${url.origin}/view-invoice/${invoice.uid}`;
    window.open(invoceUrl);
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography
        variant="body1"
        color="secondary"
        sx={{ cursor: "pointer", lineHeight: 0 }}
        onClick={handleView}
      >
        <Tooltip title="Προβολή" placement="top">
          <Visibility />
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );
}

export default InvoicesActionCell;
